import { createSelector } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { selectActiveScene } from '@wsc/redux_stores/sceneLoadReducer';

const mediaStatesSelector = createSelector(
	[(state) => state.mediaController, selectActiveScene],
	(mediaController, activeScene) => {
		const {
			storeMusicRef,
			mediaStack,
			clearMediaStack,
			setStoreMusicPlayState,
			persistOnSceneChange,
		} = mediaController;
		return {
			storeMusicRef,
			mediaStack,
			clearMediaStack,
			setStoreMusicPlayState,
			persistOnSceneChange,
			activeScene,
		};
	},
);

/**
 * Component that manages the media stack and store music play state
 * @component MediaManager
 * @category Media
 *
 * @returns {null}
 */
const MediaManager = () => {
	const {
		storeMusicRef,
		mediaStack,
		clearMediaStack,
		setStoreMusicPlayState,
		persistOnSceneChange,
		activeScene,
	} = useSelector(mediaStatesSelector);

	const dispatch = useDispatch();

	/**
	 * Clear the media stack when the scene changes if `persistOnSceneChange` is false
	 */
	useEffect(() => {
		if (persistOnSceneChange) return;
		if (mediaStack.length === 0) return;
		clearMediaStack();
	}, [activeScene]);

	/**
	 * Pause the store music when the media stack is not empty
	 * Resume the store music when the media stack is empty
	 */
	useEffect(() => {
		if (!storeMusicRef) return;
		if (mediaStack.length > 0) {
			dispatch(
				setStoreMusicPlayState({
					playState: false,
					userToggled: false,
				}),
			);
			return;
		}

		dispatch(
			setStoreMusicPlayState({
				playState: true,
				userToggled: false,
			}),
		);
	}, [storeMusicRef, mediaStack]);

	return null;
};

export default MediaManager;
